export default __webpack_public_path__ + "static/media/shop_3.fe3691e5.gif";